/*
  GW Startseite (13.10.2026): Direktkauf in den gw-home-Kacheln ohne Seitenwechsel.
  Nur Formulare mit [data-gw-wk] (snippets/gw-home-karte). Ohne JS bleibt das normale Formular an /cart/add.
  Ablauf: POST /cart/add.js → Ereignis „apps:product-added-to-cart“ (Stiletto aktualisiert damit den Zähler
  [data-js-cart-count] im Header und den Inhalt des Warenkorb-Drawers, ohne ihn zu öffnen) → Bestätigung am Button
  (ca. 2 s) und dauerhaft in der Meldung darunter (role=status, aria-live=polite) mit Link „Zum Warenkorb“.
  Fehler (z. B. ausverkauft, Höchstmenge) werden sichtbar in derselben Meldung angezeigt.
  Das Script steht je Kachel im HTML; die Sperre unten sorgt dafür, dass es nur einmal arbeitet.
  L9 (16.10.2026): Ladezustand über window.gwWk.ladenAn/ladenAus (Theme-Ladelinie, aria-busy, Sperre, Rückfall nach 10 s),
  Fehlertexte über window.gwWk.fehlerText („Leider nicht mehr genug auf Lager“ / „Hat nicht geklappt – bitte erneut versuchen“).
  L7 (15.10.2026): mit assets/gw-warenkorb.js (Warenkorb-Mischform) meldet es Erfolge an window.gwWk.hinzugefuegt().
*/
(function () {
  if (window.gwHomeWk) return;
  window.gwHomeWk = true;
  if (!window.fetch || !window.FormData) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function meldung(el, art, titel, text, cartUrl) {
    el.className = 'gw-h-wk__msg gw-h-wk__msg--' + art;
    el.textContent = '';
    var vh = document.createElement('span');
    vh.className = 'gw-h-vh';
    vh.textContent = titel + ': ';
    el.appendChild(vh);
    var t = document.createElement('span');
    t.className = 'gw-h-wk__mt';
    t.textContent = text;
    el.appendChild(t);
    if (art === 'ok') {
      el.appendChild(document.createTextNode(' '));
      var a = document.createElement('a');
      a.href = cartUrl || ROOT + 'cart';
      a.textContent = 'Zum Warenkorb';
      el.appendChild(a);
    }
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[data-gw-wk]')) return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"]');
    var msg = f.querySelector('[data-gw-wk-msg]');
    var titel = f.getAttribute('data-gw-wk-titel') || '';
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;

    clearTimeout(btn._gwT);
    if (msg && msg.className.indexOf('--fehler') > -1) { msg.className = 'gw-h-wk__msg'; msg.textContent = ''; }
    var wk = window.gwWk && window.gwWk.ladenAn ? window.gwWk : null;
    var tok = null;
    if (wk) {
      btn.classList.remove('is-ok');
      var bo = btn.querySelector('.gw-h-wk__t'); if (bo && bo._gwAlt) bo.textContent = bo._gwAlt;
      tok = wk.ladenAn([btn], function () { btn.removeAttribute('aria-disabled'); });
    } else {
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-laden');
    }

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(f)
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, s: r.status, d: d }; }, function () { return { ok: r.ok, s: r.status, d: {} }; });
      })
      .then(function (x) {
        if (!x.ok || x.d.status) {
          var info = (x.d && (x.d.description || x.d.message)) || '';
          var er = new Error(info); er.s = x.s || x.d.status;
          throw er;
        }
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { detail: { item: x.d } }));
        if (wk) wk.ladenAus(tok);
        btn.classList.remove('is-laden');
        btn.classList.add('is-ok');
        var bt = btn.querySelector('.gw-h-wk__t');
        if (bt) { if (!bt._gwAlt) bt._gwAlt = bt.textContent; bt.textContent = 'Im Warenkorb'; }
        /* L7 Warenkorb (15.10.2026): Ist assets/gw-warenkorb.js geladen, übernimmt es Bestätigung und Ansage (Mischform:
           1. Artikel der Sitzung → großer Warenkorb, sonst Karte/Snackbar). Dann keine zweite Meldung hier (sonst doppelte Ansage). */
        if (window.gwWk && window.gwWk.hinzugefuegt) {
          if (msg) { msg.className = 'gw-h-wk__msg'; msg.textContent = ''; }
          window.gwWk.hinzugefuegt({ item: x.d, ausloeser: btn });
        } else if (msg) meldung(msg, 'ok', titel, 'Hinzugefügt.', f.getAttribute('data-gw-wk-cart'));
        btn._gwT = setTimeout(function () {
          btn.classList.remove('is-ok');
          if (bt && bt._gwAlt) bt.textContent = bt._gwAlt;
        }, 2000);
      })
      .catch(function (err) {
        if (wk) wk.ladenAus(tok);
        btn.classList.remove('is-laden', 'is-ok');
        var bf = btn.querySelector('.gw-h-wk__t');
        if (bf && bf._gwAlt) bf.textContent = bf._gwAlt;
        if (wk && wk.nachFehler) wk.nachFehler(err.s);
        var ft = wk ? wk.fehlerText(err.s, err.message) : 'Nicht in den Warenkorb gelegt. ' + (err.message || 'Bitte später erneut versuchen.');
        if (msg) meldung(msg, 'fehler', titel, ft, '');
      })
      .then(function () {
        if (wk) wk.ladenAus(tok);
        btn.removeAttribute('aria-disabled');
      });
  });
})();
